import api from './api';

/**
 * Servicio para gestionar la generación de Excel con fotos de vales de requisiciones
 */
const requisitionValesService = {
  /**
   * Genera un archivo Excel con las fotos de vales de las requisiciones del mantenimiento
   * @param {number} maintenanceId - ID del mantenimiento
   * @returns {Promise} Promesa que descarga el archivo Excel
   */
  generateValesExcel: async (maintenanceId) => {
    try {
      console.log(`📋 Generando Excel de vales para mantenimiento ${maintenanceId}`);
      
      const response = await api({
        method: 'POST',
        url: `/requisition-vales/generate-excel/${maintenanceId}`,
        responseType: 'blob', // Importante para descargar archivos
        timeout: 60000 // 60 segundos de timeout
      });

      // Crear un enlace temporal para descargar el archivo
      const blob = new Blob([response.data], { 
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
      });
      
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      
      // Extraer el nombre del archivo del header Content-Disposition si existe
      const contentDisposition = response.headers['content-disposition'];
      let fileName = `Vales_Mantenimiento_${maintenanceId}_${Date.now()}.xlsx`;
      
      if (contentDisposition) {
        const fileNameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        if (fileNameMatch && fileNameMatch[1]) {
          // Limpiar el nombre: quitar comillas y espacios
          fileName = fileNameMatch[1].replace(/['"]/g, '').trim();
          // Quitar guion bajo final si existe
          fileName = fileName.replace(/_$/, '');
        }
      }
      
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      
      // Limpiar
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
      
      console.log(`✅ Excel de vales descargado: ${fileName}`);
      return { success: true, fileName };
      
    } catch (error) {
      console.error('❌ Error generando Excel de vales:', error);
      
      // Si el error tiene respuesta blob, intentar leer el mensaje de error
      if (error.response && error.response.data instanceof Blob) {
        try {
          const text = await error.response.data.text();
          const errorData = JSON.parse(text);
          throw new Error(errorData.error || 'Error generando el Excel de vales');
        } catch (parseError) {
          throw new Error('Error generando el Excel de vales');
        }
      }
      
      throw error;
    }
  }
};

export default requisitionValesService;
